import './QueryRisk.scss'
import React, { Component } from 'react'
import { withRouter } from '../../helpers/withRouter'
import { withTranslation } from 'react-i18next'
import { ReportService, SessionStorageService } from '../../services'
import { Page, PageBottomBar, PageContent, PageFooter, PageHeader, PageToolbar, PageTopBar, PdfModal } from '../../layouts/Private/components'
import { Button, Col, DatePicker, Empty, Form, Input, notification, Pagination, Row, Spin, Modal, Select } from 'antd'
import { ResultsPerPageSelector, SearchBox2, PersonCard, AdvancedSearchToggleButton, AdvancedSearchFilters } from './components'
import { ModalClientCard } from '../Register/components'
import { animatePageContentPromise, getQueryFirstPagePromise } from './promises'
import { getQueryDetailsPromise, getRecordPromise } from '../Profile/promises'
import sadSmileyImage from './no-results-bg.png'
import rutFormatter from '../../helpers/formatRut'
import { getSearchesPromise } from './../AdminSearch/promises'
import { UploadProgressService } from '../../services'
import moment from 'moment'

class QueryRisk extends Component {
  state = {
    breadcrumbs: this.getBreadcrumbs(),
    isAdvancedSearchFiltersVisible: false,
    query: '',
    queryId: '',
    queryResults: [],
    queryFiltersPersonType: '',
    queryFiltersSearchScope: 'near',
    queryFiltersRegion: '',
    historyResults: [],
    historyResultsCurrentPage: 1,
    historyResultsFromNum: 0,
    historyResultsPerPage: '5',
    historyResultsTotalNum: -1,
    statusFilter: '',
    showModalPdf: false,
    pdfSource: '',
    isLoading: false,
    historySearch: '',
    dateRange: [moment().subtract(1, 'month'), moment()],
    showAuthSearchModal: null,
    isModalClientVisible: false,
    personClient: {},
    modalTitleButtons: null
  }

  historySearchDebounce = null

  async componentDidMount() {
    const { t } = this.props
    this.handlePaginationChange(1)

    this.progressService = UploadProgressService.listenProgress(
      this.props.currentUser.id,
      { onProgress: (progressData) => {
          (progressData.status == 'APROBADO' || progressData.status == 'RECHAZADO') &&
          setTimeout(() => {
            this.handlePaginationChange(1)
            notification.info({
              message: t('messages.aml.queryRisk.notifications.searchStatusUpdated.title'),
              description: <div>
                <p>{t('messages.aml.queryRisk.notifications.searchStatusUpdated.description')}</p>
                { progressData.rut && <div>{t('messages.aml.rut')}: { progressData.rut } </div> }
                { progressData.name && <div>{t('messages.aml.name')}: { progressData.name } </div> }
                <div>{t('messages.aml.status')}:&nbsp;
                  <span style={{ paddingLeft: 'unset', 
                    color: progressData.status === 'APROBADO' ? '#3d8c7a' : progressData.status === 'RECHAZADO' ? '#DC2626' : 'unset' }}
                  >
                    {progressData.status === 'APROBADO' ? ('✓ ' + t('messages.aml.searches.status.APROBADO'))
                    : progressData.status === 'RECHAZADO' ? ('✗ ' + t('messages.aml.searches.status.RECHAZADO'))
                    : ''
                    }
                  </span>
                </div>
              </div>,
            })
          }, 2000)
        },
        onError: (error) => {
          if (this.progressService) {
            try { this.progressService.close() } catch (e) { /* ignore */ }
            this.progressService = null
          }
        }
      }
    );
  }

  componentWillUnmount() {
    if (this.historySearchDebounce) {
      clearTimeout(this.historySearchDebounce)
      this.historySearchDebounce = null
    }
    if (this.progressService) {
      try { this.progressService.close() } catch (e) { /* ignore */ }
      this.progressService = null
    }
  }

  isAuthModuleEnabled = () => {
    const { currentUser } = this.props
    return currentUser.cliente.modules.includes('AUTH-SEARCH') && !currentUser.modules.includes('OFCTO')
  }

  canUserAddRegister = () => {
    const { currentUser } = this.props
    return currentUser.cliente.modules.includes('REGISTRO')
  }

  shouldShowAddRegister = (person) => {
    if (!this.isAuthModuleEnabled() || !this.canUserAddRegister()) return false
    return person.status === 'APROBADO'
  }

  getAmlRecordId = (person) => {
    if (person.searchId) return person.id + '-' + person.searchId
    else return person.id
  }

  buildPersonClientFromRecord = (record) => ({
    rut: record.rut,
    nombre: record.name,
    type: record.type,
    pais: record.pais,
    iso3: record.countryISO3,
    extId: record.extId
  })

  buildPersonClientFallback = (person) => {
    const cert = person.certificados?.[0]
    const { currentUser } = this.props
    let rut = person.rut || cert?.rut || this.state.query
    if (rut) {
      const formatted = rutFormatter.format(rut)
      if (rutFormatter.validate(formatted)) {
        rut = rutFormatter.clean(formatted)
      }else if(person.name || person.nombre || cert?.nombre) {
        rut = undefined
      }
    }
    return {
      rut,
      nombre: person.name || person.nombre || cert?.nombre,
      type: person.type || cert?.type || undefined,
      pais: person.pais || currentUser.cliente.pais,
      iso3: person.countryISO3 || person.iso3,
      extId: person.extId
    }
  }

  async handleAddToClient(person) {
    const amlRecordId = this.getAmlRecordId(person)
    let personClient

    this.setState({ isLoading: true })

    try {
      if (amlRecordId || person.resultados === 0) {
        let record
        let exists
        if(person.resultados > 0) {
          record = await getQueryDetailsPromise(amlRecordId)
          exists = record?.hasRegistro
        }else {
          const rec = await getRecordPromise(person.rut || person.nombre || person.name)
          exists = rec
          record = person
        }
        
        if(exists) {
          notification['info']({
            message: this.props.t('messages.aml.queryRisk.notifications.alreadyRegistered.title'),
            description: this.props.t('messages.aml.queryRisk.notifications.alreadyRegistered.description')
          })
          this.setState({ isLoading: false })
          return
        }else {
          personClient = this.buildPersonClientFromRecord(record)
        }
      } else {
        personClient = this.buildPersonClientFallback(person)
      }
    } catch (e) {
      personClient = this.buildPersonClientFallback(person)
    }

    if(!personClient.type) {
      delete personClient.type
    }
    if(personClient.rut === personClient.nombre) {
      delete personClient.nombre
    }

    this.setState({
      isLoading: false,
      isModalClientVisible: true,
      personClient
    })
  }

  handleOnOkModalClient() {
    this.setState({ isModalClientVisible: false, modalTitleButtons: null })
  }

  handleOnCancelModalClient() {
    this.setState({ isModalClientVisible: false, modalTitleButtons: null })
  }

  getBreadcrumbs() {
    const { t } = this.props

    const breadcrumbs = [
      { title: t('messages.aml.query'), icon: 'file-search', link: '/consulta2' }
    ]

    return breadcrumbs
  }

  async handleChange(e) {
    const { queryId, isSearch } = this.state
    const newValue = e.target.value

    await this.setState({ query: newValue })
    if (newValue === '') {
      await this.setState({
        query: '',
        queryId: '',
      })

      await SessionStorageService.delete('latest_Query')
      await SessionStorageService.delete('latest_QueryId')
      await SessionStorageService.delete('latest_QueryResultsCurrentPage')
      await SessionStorageService.delete('latest_QueryResultsFromNum')
      await SessionStorageService.delete('latest_QueryResultsTotalNum')
    }
  }

  async handleQuery(text) {
    const { currentUser, t } = this.props

    if (text !== '') {
      const { queryFiltersPersonType, queryFiltersSearchScope, queryFiltersRegion, subclientId, historyResultsPerPage } = this.state

      // const isSubclientSelected = this.validateSubclientSelection()

      await this.setState({ isLoading: true, queryResults: [], query: text })

      await this.handlePaginationChange(1, true)

      // if (isSubclientSelected) {
      const queryFirstPage = await getQueryFirstPagePromise(text, subclientId, 1, queryFiltersPersonType, queryFiltersSearchScope, queryFiltersRegion)

      let results = queryFirstPage.results
      const isSingleGreenResult = queryFirstPage.size === 1 && String(results?.[0]?.amlStatus).toUpperCase() === 'GREEN'
      if(queryFirstPage.size != 1) {
        results = [{ name: text, hasPdf: queryFirstPage.size === 0, resultados: queryFirstPage.size, status: queryFirstPage.size === 0 ? 'APROBADO' : null }]
        if(queryFirstPage.size == 0) {
          results[0].compliance = {PEPSAN: {bases: []}, KYCAME: {bases: []}, UBOCOM: {bases: []}}
        }
      }else if(results.length === 1) {
        results[0].status = isSingleGreenResult ? 'APROBADO' : 'PENDIENTE'
      }
      await this.setState({
        queryId: queryFirstPage.searchId,
        queryResults: results,
        isLoading: false,
        totalResults: queryFirstPage.size,
        isSearch: true
      })
      if (queryFirstPage.size > 1) {
        Modal.warning({
          title: t('messages.aml.results'),
          content: t('messages.aml.multipleMatchesComplianceMessage')
        })
      }else if (queryFirstPage.size === 1) {
        //Mostrar pdf
        if (this.isAuthModuleEnabled() && !isSingleGreenResult) {
          this.setState({ showAuthSearchModal: 1 })
        } else {
          this.downloadPdf(queryFirstPage.results[0]);
        }
      } else if (queryFirstPage.size === 0) {
        if (this.isAuthModuleEnabled()) {
          this.setState({ showAuthSearchModal: 0 })
        } else {
          this.handleDownloadCertificate(queryFirstPage.searchId)
        }
      }
    }
  }

  async handleSearch(text) {
    if (text) {
      return this.handleQuery(text)
    }
  }

  isDocumentId(value) {
    if (!value) return false
    const cleaned = value.replace(/[.\-\s]/g, '')
    return /^[0-9A-Za-z]+$/.test(cleaned) && cleaned.length >= 2
  }

  normalizeDocumentId(value) {
    return value.replace(/[.\-\s]/g, '').toUpperCase()
  }

  getHistoryFilters() {
    const { statusFilter, historySearch, dateRange } = this.state
    const filters = {
      modo: 'ONLINE',
      status: statusFilter
    }

    if (dateRange && dateRange[0] && dateRange[1]) {
      filters.optDates = 'RANGE'
      filters.fromDate = dateRange[0].format('DD/MM/YYYY')
      filters.toDate = dateRange[1].format('DD/MM/YYYY')
    } else {
      filters.optDates = 'ALL'
    }

    const search = (historySearch || '').trim()
    if (search) {
      filters.name = search
      if (this.isDocumentId(search)) {
        filters.rut = this.normalizeDocumentId(search)
      }
    }

    return filters
  }

  async handlePaginationChange(from, isSearch = false) {
    const { historyResultsPerPage } = this.state
    const fromNum = (from - 1) * historyResultsPerPage

    await animatePageContentPromise.grow(historyResultsPerPage)

    if(!isSearch) {
      this.setState({
        showAuthSearchModal: null,
        query: '',
        queryResults: [],
        isSearch: false,
        totalResults: undefined
      })
    }

    this.setState({ isLoading: true, historyResultsFromNum: fromNum, isSearch })

    return getSearchesPromise(
      fromNum,
      from === 1 && isSearch ? historyResultsPerPage - 1 : historyResultsPerPage,
      this.getHistoryFilters(),
      this.props.currentUser.id
    ).then(queryResults => {
      const records = (queryResults && queryResults.records) ? queryResults.records : []
      this.setState({
        historyResults: records.map((item) => {
          return {...item, 
            formatRut: item.certificados?.length > 0 && item.certificados[0].rut ? (item.certificados[0].formatRut ?? item.certificados[0].rut) : item.formatRut && item.rut && item.formatRut.length > item.rut.length ? item.formatRut : item.rut,
            name: item.certificados?.length > 0 && item.certificados[0].nombre ? item.certificados[0].nombre : item.nombre,
            compliance: item.certificados?.length > 0 ? item.certificados[0].compliance : null,
            type: item.certificados?.length > 0 ? item.certificados[0].type : 'Person',
          }
        }),
        historyResultsCurrentPage: from,
        historyResultsTotalNum: queryResults && typeof queryResults.total === 'number' ? queryResults.total : 0,
        isLoading: false
      })
    }).catch(() => {
      this.setState({
        historyResults: [],
        historyResultsCurrentPage: from,
        historyResultsTotalNum: 0,
        isLoading: false
      })
    })
  }

  handlePersonMouseOver(e) {
    const person = e.target

    person.className = 'person-card mouseover'

    window.setTimeout(() => {
      person.className = 'person-card'
    }, 500)
  }

  handlePersonMouseOut(e) {
    const person = e.target

    person.className = 'person-card mouseout'

    window.setTimeout(() => {
      person.className = 'person-card'
    }, 500)
  }

  closeHandlerPdfModal() {
    this.setState({
      showModalPdf: false
    })
  }

  async handleDownloadCertificate(paramId) {
    const { queryId } = this.state;
    let qId = queryId;
    if((!queryId || queryId === '') && paramId && typeof paramId === 'string') {
      qId = paramId;
    }
    //window.open(apiConfig.urlAml + '/pdfUNIQUE.pdf?bId=' + queryId)

    this.setState({
      isLoading: true
    })
    const pdf = await ReportService.pdfToObj('/pdfSearchResults', { id: decodeURIComponent(qId) }, null, 'report.pdf');
    
    this.setState({
      showModalPdf: true,
      pdfSource: pdf.data,
      isLoading: false
    })
  }

  handleOnChangeSubclient(subclientId) {
    this.setState({ subclientId })
  }

  onChangeRegionHandler(pais) {
    this.setState({ queryFiltersRegion: pais })
  }

  handleQueryTypeChange(e) {
    this.setState({ queryFiltersPersonType: e.target.value })
  }

  handleSearchChange(e) {
    this.setState({ queryFiltersSearchScope: e.target.value })
  }

  handleStatusFilterChange = value => {
    this.setState({ statusFilter: value }, () => {
      this.handlePaginationChange(1)
    })
  }

  handleHistorySearchChange = e => {
    const value = e.target.value
    this.setState({ historySearch: value })

    if (this.historySearchDebounce) {
      clearTimeout(this.historySearchDebounce)
    }
    this.historySearchDebounce = setTimeout(() => {
      this.handlePaginationChange(1)
    }, 400)
  }

  handleDateRangeChange = dates => {
    this.setState({ dateRange: dates && dates.length ? dates : null }, () => {
      this.handlePaginationChange(1)
    })
  }

  getEstadoFiltro(person) {
    if (person?.resultados === 0) return 'NO_MATCH'
    if (person?.resultados > 1) return 'TOO_MATCH'
    return person?.status || ''
  }

  async handleAdvancedSearchButtonClick() {
    await this.setState(prevState => {
      return { isAdvancedSearchFiltersVisible: !prevState.isAdvancedSearchFiltersVisible }
    })
  }

  handleScrollToTop(duration) {
    const scrollStep = -window.scrollY / (duration / 15)
    const scrollInterval = setInterval(function () {
      if (window.scrollY !== 0) {
        window.scrollBy(0, scrollStep)
      } else clearInterval(scrollInterval)
    }, 15)
  }

  downloadPdf(person) {
    if(person?.id) {
      this.setState({
        isLoading: true
      })
      ReportService.pdfToObj('/pdfCompliance.pdf', { id: decodeURIComponent(person.id) }).then(pdf => {
        this.setState({
          showModalPdf: true,
          pdfSource: pdf.data,
          isLoading: false
        })
      })
    }
  }


  async downloadPdfHis(record) {
    if (record.certificados !== null && record.certificados.length > 0) {
      if(record.status === 'APROBADO' && this.isAuthModuleEnabled() && record.resultados > 0) {
        if(record.searchId && record.certificados.length === 1) {
          this.downloadPdf({ id: record.id + "-" + record.searchId})
        }
      }else {
        const obj = await ReportService.pdfToObj('/certificate', { searchId: record.id, pdf: record.certificados[0].pdf }, null, 'report.pdf')
        this.setState({
          showModalPdf: true,
          pdfSource: obj.data
        })
      }
    }
  }

  async handleOnChangeResultsNum(e) {
    await this.setState({ historyResultsPerPage: e.target.value })
    //await LocalStorageService.create('queryResultsPerPage', e.target.value)

    this.handlePaginationChange(1)
  }

  formatRut(rut) {
    let rutVal = rutFormatter.format(rut);
    let rutFull

    rut = rutVal;
    if (rutVal && rutVal.length > 0) {
      var isValid = rutFormatter.validate(rutVal);
      if (isValid) {
        rutFull = rutFormatter.clean(rutVal);
      }
    }

    return {
      rut,
      rutFull
    };
  }

  render() {
    const { currentUser, t } = this.props
    const { getFieldDecorator } = this.props.form
    const { breadcrumbs,
      isAdvancedSearchFiltersVisible,
      query,
      queryResults,
      historyResults,
      historyResultsCurrentPage,
      historyResultsPerPage,
      historyResultsTotalNum,
      showModalPdf,
      pdfSource,
      isLoading,
      totalResults,
      isSearch,
      showAuthSearchModal,
      showDownloadView,
      queryFiltersPersonType,
      queryFiltersSearchScope,
      queryFiltersRegion,
      statusFilter,
      historySearch,
      dateRange,
      isModalClientVisible,
      personClient,
    } = this.state

    const authSearchModule = this.isAuthModuleEnabled()
    const { RangePicker } = DatePicker
    return (
      <div id="query-risk" style={{ position: 'relative' }}>
        <PageTopBar breadcrumbs={breadcrumbs} />
        <Page>
          <PageHeader
            title={t('messages.aml.query')}
            description={t('messages.aml.queryPageDescription')}
            icon="file-search"
          >
          </PageHeader>
          <PageToolbar additionalClassName={ isAdvancedSearchFiltersVisible ? 'is-advanced-search' : '' }>
            <Form.Item>
              {getFieldDecorator('query')(<SearchBox2 onChange={this.handleChange.bind(this)} onSearch={this.handleSearch.bind(this)} currentQuery={query} loading={isLoading} />)}
            </Form.Item>
            <AdvancedSearchToggleButton defaultValue={isAdvancedSearchFiltersVisible} onChangeHandler={this.handleAdvancedSearchButtonClick.bind(this)} />
            <AdvancedSearchFilters 
              defaultValues={{ queryFiltersPersonType, queryFiltersSearchScope, queryFiltersRegion }} 
              onChangeTypeHandler={this.handleQueryTypeChange.bind(this)} 
              onChangeSearchHandler={this.handleSearchChange.bind(this)} 
              onChangeRegionHandler={this.onChangeRegionHandler.bind(this)} 
              currentUser={currentUser}
            />
          </PageToolbar>
          <PageContent>
            <div style={{ position: 'relative' }}>
              {isLoading && (
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'rgba(255, 255, 255, 0.65)',
                    zIndex: 20,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <Spin size={'large'} />
                </div>
              )}
              <div className="page-content-inner" style={{ marginBottom: 20 }}>
              <div style={{marginBottom: 10}}>
                {/* <Row type='flex' justify='center'>
                  <span style={{fontSize: 12}}>
                    Resultados por página
                  </span>
                </Row> */}
                <Row type='flex' justify='center' style={{padding:5}}>
                  <ResultsPerPageSelector value={ historyResultsPerPage } onChange={ this.handleOnChangeResultsNum.bind(this) } />
                </Row>
              </div>
              <div className="table-headers">
                { authSearchModule ?
                  <Row>
                    <Col xs={5}>
                      <Input
                        size="small"
                        allowClear
                        value={historySearch}
                        placeholder={t('messages.aml.nameOrRut')}
                        onChange={this.handleHistorySearchChange}
                        className="history-search-input"
                      />
                    </Col>
                    <Col xs={5}>
                      {t('messages.aml.riskLevelInformation')}
                    </Col>
                    <Col xs={4}>
                      <Select
                        size='small'
                        allowClear
                        value={statusFilter || undefined}
                        placeholder={t('messages.aml.status')}
                        onChange={this.handleStatusFilterChange}
                        style={{ width: '100%' }}
                      >
                        <Select.Option value='APROBADO'>{t('messages.aml.searches.status.APROBADO')}</Select.Option>
                        <Select.Option value='RECHAZADO'>{t('messages.aml.searches.status.RECHAZADO')}</Select.Option>
                        <Select.Option value='PENDIENTE'>{t('messages.aml.searches.status.PENDIENTE')}</Select.Option>
                        <Select.Option value='NO_MATCH'>{t('messages.aml.searches.status.NO_MATCH')}</Select.Option>
                        <Select.Option value='TOO_MATCH'>{t('messages.aml.searches.status.TOO_MATCH')}</Select.Option>
                      </Select>
                    </Col>
                    <Col xs={4}>
                      <RangePicker
                        size="small"
                        format="DD/MM/YYYY"
                        value={dateRange}
                        allowClear
                        onChange={this.handleDateRangeChange}
                        style={{ width: '100%' }}
                        className="history-date-range"
                        placeholder={[t('messages.aml.fromDatePlaceholder'), t('messages.aml.toDatePlaceholder')]}
                      />
                    </Col>
                    <Col xs={6}>
                      {t('messages.aml.actions')}
                    </Col>
                  </Row>
                  :
                  <Row>
                    <Col xs={6}>
                      <Input
                        size="small"
                        allowClear
                        value={historySearch}
                        placeholder={t('messages.aml.nameOrRut')}
                        onChange={this.handleHistorySearchChange}
                        className="history-search-input"
                      />
                    </Col>
                    <Col xs={6}>
                      {t('messages.aml.riskLevelInformation')}
                    </Col>
                    <Col xs={5}>
                      <RangePicker
                        size="small"
                        format="DD/MM/YYYY"
                        value={dateRange}
                        allowClear
                        onChange={this.handleDateRangeChange}
                        style={{ width: '100%' }}
                        className="history-date-range"
                        placeholder={[t('messages.aml.fromDatePlaceholder'), t('messages.aml.toDatePlaceholder')]}
                      />
                    </Col>
                    <Col xs={7}>
                      {t('messages.aml.actions')}
                    </Col>
                  </Row>
                }
              </div>
              {queryResults &&
                  queryResults.map((person, index) => (
                    <PersonCard
                      key={index}
                      person={person}
                      currentUser={currentUser}
                      onClick={totalResults === 0 ? this.handleDownloadCertificate.bind(this) : this.downloadPdf.bind(this)}
                      showAddRegister={this.shouldShowAddRegister(person)}
                      onClickAddRegister={this.handleAddToClient.bind(this)}
                    />
                  ))
              }
              { showDownloadView &&
                <div style={{ marginTop: 16 }}>
                  <div style={{
                    background: '#fff', border: '1px solid rgba(0,0,0,.08)',
                    borderRadius: 6, padding: '40px 24px', textAlign: 'center'
                  }}>
                    <div style={{
                      width: 64, height: 64, borderRadius: '50%',
                      border: '2px solid #3d8c7a', display: 'flex',
                      alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px'
                    }}>
                      <span style={{ color: '#3d8c7a', fontSize: 28, lineHeight: 1 }}>✓</span>
                    </div>
                    <p style={{ marginBottom: 4 }}>{t('messages.aml.noFindingsForRut', { query })}</p>
                    <p style={{ color: 'rgba(0,0,0,.45)', marginBottom: 28 }}>{t('messages.aml.downloadCertificateNoFindingsMessage')}</p>
                  </div>
                  <div style={{ textAlign: 'center', padding: 12, alignItems: 'center', display: 'flex', gap: 10, justifyContent: 'center' }}>
                    <Button
                      type="primary"
                      size="large"
                      icon={isLoading ? 'loading' : 'download'}
                      disabled={isLoading}
                      onClick={this.handleDownloadCertificate.bind(this)}
                      style={{ minWidth: 220 }}
                    >
                      {t('messages.aml.queryNoResultDownloadPDF')}
                    </Button>
                    <Button
                      size="large"
                      style={{ minWidth: 220 }}
                      onClick={() => this.setState({
                        showDownloadView: false,
                        query: '',
                        isSearch: false,
                      })}
                    >
                      {t('messages.aml.backToStart')}
                    </Button>
                  </div>
                </div>
              }
              {historyResults &&
                historyResults.map((person, index) => (
                  <PersonCard
                    key={index}
                    person={person}
                    currentUser={currentUser}
                    onClick={this.downloadPdfHis.bind(this)}
                    queryRisk={true}
                    showAddRegister={this.shouldShowAddRegister(person)}
                    onClickAddRegister={this.handleAddToClient.bind(this)}
                  />
                ))
              }
              {!isLoading && historyResultsTotalNum === 0 && (!queryResults || queryResults.length === 0) && !showDownloadView && (
                <div style={{ padding: '40px 0' }}>
                  <Empty description={t('messages.aml.queryNoResult')} />
                </div>
              )}
              { totalResults === 0 && historyResultsTotalNum === 0 && query.length &&
                  <div className="zero-results">
                    <br />
                    <div align="center" style={{ height: '200px' }}><img src={sadSmileyImage} alt="" /></div>
                    <br /><br /><br /><br /><br /><br />
                    <div align="center" style={{ fontSize: '1.8em' }}>{t('messages.aml.queryNoResult')}.</div>
                    <div align="center">{t('messages.aml.queryNoResultDownloadPDFPhrase')} :</div>
                    <br />
                    <div>
                      <Button disabled={isLoading} type="primary" size="large" icon={isLoading ? "loading" : "file-pdf"} onClick={this.handleDownloadCertificate.bind(this)}>
                        {t('messages.aml.viewPdf')}
                      </Button>
                    </div>
                  </div>
              }

              </div>
            </div>
          </PageContent>
          <PageFooter>
            {historyResultsTotalNum > 0 &&
              <Pagination
                key={Math.floor(Math.random() * 100000000)}
                current={historyResultsCurrentPage}
                onChange={(page) => this.handlePaginationChange(page)}
                pageSize={historyResultsPerPage}
                total={historyResultsTotalNum}
              />
            }
          </PageFooter>
          {showModalPdf && <PdfModal closeHandler={this.closeHandlerPdfModal.bind(this)} pdfSource={pdfSource} embeded={true} isObj={true} />}

          { isModalClientVisible &&
            <Modal
              wrapClassName="modal-fichaCliente-register"
              style={{ top: '10px' }}
              title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                  <span>{t('messages.aml.register')}</span>
                  {this.state.modalTitleButtons}
                </div>
              }
              visible={true}
              onCancel={this.handleOnCancelModalClient.bind(this)}
              cancelText="Cerrar"
              footer={null}
              width={'95vw'}
            >
              <ModalClientCard
                key={`${personClient.rut || ''}-${personClient.nombre || ''}-${personClient.extId || ''}`}
                currentUser={currentUser}
                item={personClient}
                handleCancel={this.handleOnOkModalClient.bind(this)}
                onTitleButtons={(buttons) => this.setState({ modalTitleButtons: buttons })}
              />
            </Modal>
          }

          { showAuthSearchModal !== null &&
            <Modal
              visible={true}
              footer={null}
              closable={false}
              centered
              width={400}
            >
              <div style={{ textAlign: 'center', padding: '20px 0 10px' }}>
                <div style={{
                  width: 64, height: 64, borderRadius: '50%',
                  border: "2px solid #" + (showAuthSearchModal === 0 ? '3d8c7a' : 'B45309'), display: 'flex',
                  alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px',
                  background: showAuthSearchModal === 0 ? 'rgba(232,245,240,0.6)' : 'rgba(254,243,199,0.5)'
                }}>
                  <span style={{ color: showAuthSearchModal === 0 ? '#3d8c7a' : '#B45309', fontSize: 28, lineHeight: 1 }}>
                    { showAuthSearchModal === 0 ? '✓' : '!' }
                  </span>
                </div>
                <h3 style={{ fontWeight: 700, marginBottom: 8 }}>
                  { showAuthSearchModal === 0 ? t('messages.aml.thirdPartyAuthorized') : t('messages.aml.complianceAuthorizationRequired') }
                </h3>
                <p style={{ color: 'rgba(0,0,0,.55)', marginBottom: 28 }}>
                  { showAuthSearchModal === 0 ?
                    t('messages.aml.noFindingsForQuery')
                    :
                    t('messages.aml.complianceAuthorizationNeededMessage')
                  }
                </p>
                <div style={{ display: 'flex', gap: 12, justifyContent: 'center' }}>
                  { showAuthSearchModal === 0 &&
                    <Button
                      onClick={() => {
                        this.setState({
                          showAuthSearchModal: null,
                          query: '',
                          queryResults: [],
                          isSearch: false,
                          totalResults: undefined
                        })
                      }}
                    >
                        {t('messages.aml.backToStart')}
                    </Button>
                  }
                  <Button
                    type="primary"
                    onClick={() => this.setState({ showAuthSearchModal: null, showDownloadView: (showAuthSearchModal === 0) })}
                  >
                    {t('messages.aml.modalRequestOpt.confirmModal.ok')}
                  </Button>
                </div>
              </div>
            </Modal>
          }
        </Page>
        <PageBottomBar breadcrumbs={breadcrumbs} />
        {/* { isSelectedPersonVisible && ReactDOM.createPortal(<ProfilePage currentPerson={ selectedPerson } currentUser={ currentUser } isTransition />, document.body) } */}
      </div>
    )
  }
}

const WrappedTimeRelatedForm = Form.create({ name: 'query' })(QueryRisk)

export default withRouter(withTranslation()(WrappedTimeRelatedForm))
